<div class="sw-cms-preview-gallery-buybox">
    <div class="sw-cms-preview-gallery-buybox__gallery">
        <div class="sw-cms-preview-gallery-buybox__images">
            <img
                :src="assetFilter('/administration/static/img/cms/preview_glasses_small.jpg')"
                alt=""
            >
            <img
                :src="assetFilter('/administration/static/img/cms/preview_glasses_small.jpg')"
                alt=""
            >
            <img
                :src="assetFilter('/administration/static/img/cms/preview_glasses_small.jpg')"
                alt=""
            >
             <img
                :src="assetFilter('/administration/static/img/cms/preview_glasses_small.jpg')"
                alt=""
            >
        </div>

        <div class="sw-cms-preview-gallery-buybox__slider">
            <sw-icon
                name="regular-chevron-left-xs"
                size="12"
            />
            <img
                :src="assetFilter('/administration/static/img/cms/preview_glasses_small.jpg')"
                alt=""
            >
            <sw-icon
                name="regular-chevron-right-xs"
                size="12"
            />
        </div>
    </div>

    <div class="sw-cms-preview-gallery-buybox__buybox">
        <sw-cms-el-preview-buy-box />
    </div>
</div>
